import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { categories } from "../../common/JobData";

const Categories = () => {
  return (
    <React.Fragment>
      <section className="section bg-light py-4 py-md-5" id="categories">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7} >
              <div className="text-center mb-3 mb-md-5">
                <h1 className="mb-3 ff-secondary fw-bold text-capitalize lh-base">
                  Talab yuqori bo'lgan {" "}
                  <span className="text-primary">ish o'rinlari</span> toifalari
                </h1>
                <p className="text-muted">
                  Bo'limlarni ustini bosib ular ichidagi vakansiyalarni ko'rishingiz mumkin
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {categories.map((item, key) => (
              <Col lg={3} md={6} key={key}>
                <Card className="shadow-none text-center py-3">
                  <CardBody className="py-4">
                    <div className="avatar-sm position-relative mb-4 mx-auto">
                      <div className="job-icon-effect"></div>
                      <div className="avatar-title bg-transparent text-success rounded-circle">
                        <i className={item.icon}></i>
                      </div>
                    </div>
                    <Link to="#" className="to-link">
                      <h5 className="fs-17 pt-1">{item.lable}</h5>
                    </Link>
                    <p className="mb-0 text-muted">{item.jobs}</p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Categories;
